import Layer from "@mozaic-ds/freemarker/js/modules/_layer";
import { CONTEXTUALIZATION_LAYER, CONTEXTUALIZATION_LAYER_SEARCH_MODE_EVENT, DATA_SELECTOR_ID, IS_USER_CONTEXTUALIZED, STORE_CARD, STORE_LAYER_TITLE_CLASS, STORE_SEARCH, storeContextTracking, storeSearchInfo } from "./utils/context-layer-variables";
import { pushLayerDisplayTmsEvent, pushStoreCardButtonTracking, sendCdlEventOnStepDisplay } from "./components/tracking";
import { retrieveCustomerContextCookieValue } from "../common/cookie-finder";
import { StoreSearchData } from "./models/StoreSearchData";
import { CustomerContext } from "./models/CustomerContext";
import { fetchStoresAroundRendering, initStoreSearchResultEvents } from "./components/store-search";
import { geolocateUserFromPosition, initGeolocateUserTracking } from "./components/navigator-geolocation";
import { initAutocompletePredictionEvents } from "./components/autocomplete-predictions";
import { Coordinates } from "./models/Coordinates";
import { StoreSearchType } from "./enums/StoreSearchType";
import { getNotificationSuccessTemplate } from "./api/notification-success-service";
import { showNotificationSuccessPopup } from "./components/notification-success";
const KL_HIDDEN_CLASS = 'kl-hidden';
class ContextLayer extends lm.Composant {
  constructor(componentName) {
    super(componentName);
    this.addRefreshLayerEvent();
  }
  init() {
    var _a;
    this.initLocalVariables();
    this.checkContextNotification();
    this.initContextLayer();
    this.initLayerListeners();
    if (this.isUserContextualizedWithStoreCookie) {
      this.initChangeStoreButtonEvent();
      this.initStorePageButtonEvent();
    } else {
      (_a = this.storeSearchContainer) === null || _a === void 0 ? void 0 : _a.classList.remove(KL_HIDDEN_CLASS);
    }
    this.initStoreSearchViewEvents();
    if (this.storeSearchContainer) initAutocompletePredictionEvents(this.storeSearchContainer);
  }
  checkContextNotification() {
    if (localStorage.getItem(IS_USER_CONTEXTUALIZED)) {
      getNotificationSuccessTemplate(template => showNotificationSuccessPopup(this.contextLayerContainer, template), () => {
        console.error('Error displaying notification success popup.');
      });
      localStorage.removeItem(IS_USER_CONTEXTUALIZED);
    }
  }
  initLocalVariables() {
    var _a, _b, _c, _d, _e;
    this.contextLayerContainer = document.querySelector(`[${DATA_SELECTOR_ID}="component-context-layer"]`);
    this.storeCardContainer = (_a = this.contextLayerContainer) === null || _a === void 0 ? void 0 : _a.querySelector(`[${DATA_SELECTOR_ID}="${STORE_CARD}"]`);
    this.storeSearchContainer = (_b = this.contextLayerContainer) === null || _b === void 0 ? void 0 : _b.querySelector(`[${DATA_SELECTOR_ID}="${STORE_SEARCH}"]`);
    this.storeChangeButtonContainer = (_c = this.contextLayerContainer) === null || _c === void 0 ? void 0 : _c.querySelector(`[${DATA_SELECTOR_ID}="context-change-button"]`);
    this.storePageButtonContainer = (_d = this.contextLayerContainer) === null || _d === void 0 ? void 0 : _d.querySelector(`[${DATA_SELECTOR_ID}="store-space-button"]`);
    this.isUserContextualizedWithStoreCookie = ((_e = this.contextLayerContainer) === null || _e === void 0 ? void 0 : _e.dataset.isusercontextualized) === 'true';
  }
  initContextLayer() {
    this.layer = new Layer({
      'classContent': 'js-context-layer',
      'onOpen': () => {},
      'onClose': () => this.onLayerClosing()
    });
  }
  onLayerClosing() {
    var _a;
    const contextLayerTitleContainer = (_a = this.contextLayerContainer) === null || _a === void 0 ? void 0 : _a.querySelector(`.${STORE_LAYER_TITLE_CLASS}`);
    setTimeout(() => {
      this.isUserContextualizedWithStoreCookie ? this.switchLayerToStoreCardView(contextLayerTitleContainer) : this.switchLayerToStoreSearchView();
    }, 250);
    storeSearchInfo.productRef = '';
  }
  initLayerListeners() {
    window.addEventListener(CONTEXTUALIZATION_LAYER, event => this.handleLayerEventsCall(false, event));
    window.addEventListener(CONTEXTUALIZATION_LAYER_SEARCH_MODE_EVENT, event => this.handleLayerEventsCall(true, event));
  }
  handleLayerEventsCall(isSearchMode, event) {
    var _a, _b;
    if ((_a = event.detail) === null || _a === void 0 ? void 0 : _a.funnel_name) storeContextTracking.funnelName = (_b = event.detail) === null || _b === void 0 ? void 0 : _b.funnel_name;
    this.handleLayerDisplayTmsEvent();
    if (isSearchMode) {
      this.loadSearchLayer(event);
    } else {
      this.layer.open();
    }
  }
  retrieveCustomerContextCookieObject() {
    const cookie = retrieveCustomerContextCookieValue();
    if (cookie) {
      const coordinates = new Coordinates(cookie.latitude, cookie.longitude);
      return new CustomerContext(coordinates, cookie.postcode, cookie.city);
    }
    return null;
  }
  loadSearchLayer(event) {
    var _a;
    this.switchLayerToStoreSearchView();
    const customerContextCookie = this.retrieveCustomerContextCookieObject();
    if (((_a = customerContextCookie === null || customerContextCookie === void 0 ? void 0 : customerContextCookie.getCoordinates()) === null || _a === void 0 ? void 0 : _a.hasValidValues()) && this.storeSearchContainer) {
      const storeSearchResultData = new StoreSearchData(customerContextCookie.getCoordinates(), event.detail);
      storeSearchInfo.productRef = storeSearchResultData.getProductRef();
      this.editLayerTitle(storeSearchResultData.getStoreSearchType());
      fetchStoresAroundRendering(storeSearchResultData, this.storeSearchContainer).then(storesResultView => {
        if (this.storeSearchContainer) {
          initStoreSearchResultEvents(customerContextCookie, this.storeSearchContainer, storesResultView);
        }
      });
    }
    this.layer.open();
  }
  editLayerTitle(storeSearchType) {
    var _a;
    const contextLayerTitleContainer = (_a = this.contextLayerContainer) === null || _a === void 0 ? void 0 : _a.querySelector(`.${STORE_LAYER_TITLE_CLASS}`);
    if (contextLayerTitleContainer) {
      if (storeSearchType == StoreSearchType.DELIVERY) contextLayerTitleContainer.innerHTML = context_layer.i18n.delivery_layer_title;else contextLayerTitleContainer.innerHTML = context_layer.i18n.stock_layer_title;
    }
  }
  initChangeStoreButtonEvent() {
    var _a;
    (_a = this.storeChangeButtonContainer) === null || _a === void 0 ? void 0 : _a.addEventListener('click', () => {
      var _a;
      pushStoreCardButtonTracking('Change store');
      const customerContextCookie = this.retrieveCustomerContextCookieObject();
      if (((_a = customerContextCookie === null || customerContextCookie === void 0 ? void 0 : customerContextCookie.getCoordinates()) === null || _a === void 0 ? void 0 : _a.hasValidValues()) && this.storeSearchContainer) {
        const storeSearchResultData = new StoreSearchData(customerContextCookie.getCoordinates());
        fetchStoresAroundRendering(storeSearchResultData, this.storeSearchContainer).then(storesResultView => {
          if (this.storeSearchContainer) initStoreSearchResultEvents(customerContextCookie, this.storeSearchContainer, storesResultView);
        });
      }
      this.switchLayerToStoreSearchView();
      sendCdlEventOnStepDisplay('store search');
    });
  }
  initStorePageButtonEvent() {
    var _a;
    (_a = this.storePageButtonContainer) === null || _a === void 0 ? void 0 : _a.addEventListener('click', () => {
      pushStoreCardButtonTracking('Check store page');
    });
  }
  switchLayerToStoreCardView(contextLayerTitle) {
    var _a, _b;
    (_a = this.storeSearchContainer) === null || _a === void 0 ? void 0 : _a.classList.add(KL_HIDDEN_CLASS);
    (_b = this.storeCardContainer) === null || _b === void 0 ? void 0 : _b.classList.remove(KL_HIDDEN_CLASS);
    if (contextLayerTitle) contextLayerTitle.innerHTML = context_layer.i18n.context_layer_title;
  }
  switchLayerToStoreSearchView() {
    var _a;
    const contextLayerTitle = (_a = this.contextLayerContainer) === null || _a === void 0 ? void 0 : _a.querySelector(`.${STORE_LAYER_TITLE_CLASS}`);
    if (contextLayerTitle) contextLayerTitle.innerHTML = context_layer.i18n.no_context_title;
    this.storeCardContainer && this.storeCardContainer.classList.add(KL_HIDDEN_CLASS);
    this.storeSearchContainer && this.storeSearchContainer.classList.remove(KL_HIDDEN_CLASS);
  }
  handleLayerDisplayTmsEvent() {
    pushLayerDisplayTmsEvent(this.isUserContextualizedWithStoreCookie, storeContextTracking.funnelName);
  }
  initStoreSearchViewEvents() {
    if (this.storeSearchContainer) {
      const geolocateButton = this.storeSearchContainer.querySelector(`[${DATA_SELECTOR_ID}="user-locator-button"]`);
      geolocateButton === null || geolocateButton === void 0 ? void 0 : geolocateButton.addEventListener('click', geolocateUserFromPosition.bind(this, this.storeSearchContainer));
      initGeolocateUserTracking(this.storeSearchContainer);
    }
  }
  clearExpiredEventListeners() {
    window.removeEventListener(CONTEXTUALIZATION_LAYER, event => this.handleLayerEventsCall(false, event));
    window.removeEventListener(CONTEXTUALIZATION_LAYER_SEARCH_MODE_EVENT, event => this.handleLayerEventsCall(true, event));
  }
  addRefreshLayerEvent() {
    window.addEventListener("refreshContextLayerJs", () => {
      this.clearExpiredEventListeners();
      this.init();
    });
  }
}
lm.DOMReady(() => {
  const contextLayer = new ContextLayer('ContextLayer');
  contextLayer.init();
});